import { Button, Checkbox, Modal, Space } from 'antd'
import { useHistory, useLocation } from 'react-router-dom'
import { JobItem } from '../domain/items'
import ItemsList from './items-list.component'
import { useTranslation } from 'react-i18next'
import { useMemo, useState } from 'react'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import moment from 'moment'

const SelectRejectItemsModal = ({ isOpen, onClose, items, jobId }: SelectRejectItemsModalProps) => {
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const [selectedItems, setSelectedItems] = useState<JobItem[]>([])
  const nowInUtc = moment().utc()
  const pathToRedirect = useMemo(() => `/orders/${jobId}/incidence/create`, [location])

  const handleSelectItem = (item: JobItem) => {
    setSelectedItems((selectedItemsPrevState) => {
      if (selectedItemsPrevState.includes(item)) {
        return selectedItemsPrevState.filter((i) => i !== item)
      }
      return [...selectedItemsPrevState, item]
    })
  }

  const handleNext = () => {
    history.push({
      pathname: pathToRedirect,
      state: {
        selectedItems
      }
    })
  }

  return (
    <Modal
      title={t('jobs.rejectItemsModal.tittle')}
      visible={isOpen}
      onCancel={onClose}
      mask={true}
      maskStyle={{ zIndex: 10001000, background: 'rgba(0,0,0,0.45)' }}
      footer={[
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <div>
            {t('jobs.rejectItemsModal.footer.selectedItemsCount', {
              amount: selectedItems.length
            })}
          </div>
          <div>
            <Button key='back' onClick={onClose}>
              {t('jobs.rejectItemsModal.footer.cancel')}
            </Button>
            <Button key='submit' type='primary' onClick={handleNext} disabled={selectedItems.length === 0}>
              {t('jobs.rejectItemsModal.footer.next')}
            </Button>
          </div>
        </div>
      ]}
    >
      <ItemsList
        items={items}
        renderCheckbox={(item) => (
          <Checkbox
            onChange={() => handleSelectItem(item)}
            checked={selectedItems.includes(item)}
            disabled={isItemDisabledByDate(item, nowInUtc.format())}
          />
        )}
        renderComment={(item) => {
          if (isItemDisabledByDate(item, nowInUtc.format())) {
            const maxReturnDate = moment(item.claimInformation!.maxClaimDate)
            return (
              <div>
                <Space
                  size='small'
                  direction='horizontal'
                  style={{ display: 'flex', flexDirection: 'row', color: 'red' }}
                >
                  <ExclamationCircleOutlined />
                  <div>{t('jobs.rejectItemsModal.dateExpiredTittle')}</div>
                </Space>
                <div>
                  {t('jobs.rejectItemsModal.dateExpiredComment', {
                    limitDate: maxReturnDate.format('ddd, DD MMM'),
                    days: nowInUtc.diff(maxReturnDate, 'days')
                  })}
                </div>
              </div>
            )
          }
        }}
      />
    </Modal>
  )
}

const isItemDisabledByDate = (item: JobItem, nowInUtc: string) => {
  if (!item?.claimInformation?.maxClaimDate) {
    return false
  }

  const maxReturnDate = moment(item.claimInformation.maxClaimDate).utc()
  return maxReturnDate.isBefore(nowInUtc)
}

export default SelectRejectItemsModal

type SelectRejectItemsModalProps = {
  jobId: string
  isOpen: boolean
  onClose: () => void
  items: JobItem[]
}
